import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function MotivationBoostPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const goal = allAnswers.goals?.answer_key

  const isMind = goal === 'Clear my mind'
  const isSpace = goal === 'Make more space'

  const headingKey = isMind
    ? 'pages.onboarding.v2.motivationBoost.mind.heading'
    : isSpace
      ? 'pages.onboarding.v2.motivationBoost.space.heading'
      : 'pages.onboarding.v2.motivationBoost.default.heading'
  const textKey = isMind
    ? 'pages.onboarding.v2.motivationBoost.mind.text'
    : isSpace
      ? 'pages.onboarding.v2.motivationBoost.space.text'
      : 'pages.onboarding.v2.motivationBoost.default.text'

  return (
    <FeedbackPage
      emoji="🚀"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
